<p-button (click)="userMenu.toggle($event)" class="text-yellow-500 text-xl"><i class="pi pi-user"></i></p-button>
<p-popover #userMenu>
  <div>
    @if (auth.user$ | async; as user) {
    <a [routerLink]="'/profile'" aria-label="Go to profile page" class="block mb-3 hover:opacity-80 transition-opacity cursor-pointer no-underline text-inherit">
      <div class="text-lg mb-1">
        <i class="pi pi-user mr-2"></i>{{ user.name }}
      </div>
      <div class="text-sm px-1">
        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full font-semibold capitalize"
          [class.bg-gray-200]="currentPlan() === 'free'"
          [class.text-gray-700]="currentPlan() === 'free'"
          [class.bg-blue-100]="currentPlan() === 'standard'"
          [class.text-blue-700]="currentPlan() === 'standard'"
          [class.bg-yellow-100]="currentPlan() === 'pro'"
          [class.text-yellow-700]="currentPlan() === 'pro'"
          [class.bg-green-100]="currentPlan() === 'admin'"
          [class.text-green-700]="currentPlan() === 'admin'">
          <i class="pi pi-crown text-xs"></i>
          {{ currentPlan() }} plan
        </span>
      </div>
    </a>
    <div class="text-lg mb-2">
      <i class="pi pi-cog mr-2"></i
      ><a [routerLink]="'/profile'">Account Settings</a>
    </div>
    <div class="text-lg mb-2">
      @if(!themeService.isDark()) {
      <i class="pi pi-moon mr-2"></i><a (click)="toggleTheme()">Switch to Dark Mode</a>
      }@else {
      <i class="pi pi-sun mr-2"></i><a (click)="toggleTheme()">Switch to Light Mode</a>
      }
    </div>

    <div>
      <i class="pi pi-sign-out mr-2"></i
      ><button (click)="logout()">Logout</button>
    </div>

    } @else {
    <button (click)="login()">Login</button>
    }
  </div>
</p-popover>
